import { render, staticRenderFns } from "./PublicDashboardInstitution.vue?vue&type=template&id=38c103be"
import script from "./PublicDashboardInstitution.vue?vue&type=script&lang=js"
export * from "./PublicDashboardInstitution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports